import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";
import { Reward } from "./reward.model";

interface RewardsState {
  futureRewards: Reward[];
  pastRewards: Reward[];
}

interface RewardsActions {
  setRewards: (rewards: Reward[]) => void;
  reset: () => void;
}

export const RewardsStore = create<RewardsState & RewardsActions>()(
  persist(
    (set) => ({
      futureRewards: [],
      pastRewards: [],
      setRewards: rewards => {
        const now = new Date();

        const pastRewards: Reward[] = [];
        const futureRewards: Reward[] = [];

        for (const reward of rewards) {
          const end = new Date(reward.endDate);
          (end < now ? pastRewards : futureRewards).push(reward);
        }

        set({ futureRewards, pastRewards });
      },
      reset: () => set({
        pastRewards: [],
        futureRewards: [],
      }),
    }),
    {
      name: "_rewards_wallet_storage",
      storage: createJSONStorage(() => localStorage),
    }
  )
)